/* eslint-disable react/react-in-jsx-scope */
import { Avatar, Box,  } from '@mui/material'
import { Link, useNavigate } from 'react-router'
// import { useDispatch, useSelector } from 'react-redux'
// import { getCurrentUser} from '../../context/userSlice'
import axios from 'axios';
// import moment from 'moment'
// import { tokens } from "../../theme";
import { useState, useEffect, useMemo } from 'react'
import UsersActions from '../../components/dataTable/UsersActions'
import DataTable from '../../components/dataTable/DataTables';
import SearchIcon from '@mui/icons-material/Search';
// import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import Header from '../../components/Header';
// import Snackbars from '../../components/Snackbars';
// import Notistack from '../../components/Notistack';
import { useUserContext, useUserDispatch } from '../../contexts/UserContext';


// const url = process.env.REACT_APP_BASE_URL + ':' + process.env.REACT_APP_BASE_URL_PORT;
// const apiPath = process.env.REACT_APP_BASE_API;
// const SKEY = process.env.REACT_APP_SKEY;
// const apiurl = `${url}${apiPath}ActUsers/`
// const apiurl = "https://localhost:44357/api/ActUsers"

const UsersList = () => {
  // const theme = useTheme();
  // const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const user = useUserContext();
  // const dispatch = useUserDispatch();

  // const { currentUser,Conf} = useSelector(getCurrentUser);
  // const [query, setQuery] = useState([])
  const [data, setData] = useState([])
  const [rowId, setRowId] = useState(null)
  const [values, setValues] = useState({searchTxt: '',});
  const [searchTxt, setSearchTxt] = useState('')
  // const keys = ['userName','uuser','cuser']

  // const Conf = JSON.parse(localStorage.getItem("Conf"));
  // const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  // console.log(searchTxt)
  const apiurl = `${process.env.REACT_APP_API}/users.php`
  const imgurl = `${process.env.REACT_APP_URL}/image/users`
  const webpath = '/users'

  // console.log(apiurl,imgurl);
  // console.log(user);

    // const handleChange = (prop) => (event) => {
    //   // setValues({ ...values, [prop]: event.target.value });
    //   setSearchTxt(event.target.value)
    // };
  
    const handleClickClearSearchTxt = () => {
      // setValues({
      //   "searchTxt": ''
      // });
      // setQuery(values.searchTxt)
      setSearchTxt('')
    };
  
    const handleMouseDownSearchTxt = (event) => {
      event.preventDefault();
    };

    const columns  = useMemo(() => [
      { field: "id", headerName: "ID", width: 90, flex:1 },
      {
        field: "Avatar",
        headerName: "Avatar",
        renderCell:params=><Avatar src={`${imgurl}/${params.row.Avatar}`} />,
        sortable: false,
        filterable: false,
        headerAlign: 'center',
        width: 64,
        editable: false,
  
    
        // renderCell: (params) => {
        //   return <img src={`${process.env.REACT_APP_URL}/image/users/${params.row.Avatar} || '/user.png'`} alt="" />;
        // },
      },
      {
        field: "name",
        type: "string",
        headerName: "Name",
        width: 150,
        editable: true,
        flex:1, 
        minWidth:100,
      },
      // {
      //   field: "lastName",
      //   type: "string",
      //   headerName: "Last name",
      //   width: 150,
      // },
      {
        field: "email",
        type: "string",
        headerName: "Email",
        width: 200,
        editable: true,
        flex:1,
        minWidth:150, 
      },
      {
        field: "Role",
        // type: "boolean",
        headerName: "Role",
        width: 100,
        headerAlign: 'center',
        type: 'singleSelect',
        // valueOptions: roleOptions,
        valueOptions: ['Admin','User', 'Customer'],
          // valueGetter: ({ value, colDef }) => {
          //   console.log(value,colDef);
          //   const option = colDef.valueOptions.find(
          //     ({ value: optionValue }) => value === optionValue
          //   );
          //   return option.label;
          // },
        editable: true,
        flex: 0.3,
        minWidth:60,
      },
      {
        field: "isAdmin",
        type: "singleSelect",
        headerName: "Admin",
        valueOptions: ['false', 'true'],
        valueGetter: (value) => {
          return value==1? true:false;
        },
        width: 100,
        editable: true,
        flex: 0.3,
        minWidth:60,
      },
      {
        field: "actived",
        type: "boolean",
        headerName: "Actived",
        valueGetter: (value) => {
          return value==1? true:false;
        },
        width: 100,
        editable:true,
        flex: 0.3,
        minWidth:60,
      },
      {
          field: 'actions',
          headerName: 'Actions',
          type: 'actions',
          renderCell: params => <UsersActions {...{params, rowId, setRowId, webpath}} />,
          // headerClassName: 'datatable-header',
          headerAlign: 'center',
          width: 150,
          editable: false,
          // flex: 1,
      },

    ],[rowId]);

  //   const columns = useMemo(() => [
  //     { field: 'id', 
  //         headerName: 'ID', 
  //         // headerClassName: 'datatable-header',
  //         headerAlign: 'center',
  //         width: 100 ,
  //         editable: false,
  //         // flex: 1,
  //         // cellClassName: "name-column--cell",
  //     },
  //     {
  //         field: 'userAvatar',
  //         headerName: 'Avatar',
  //         // headerClassName: 'datatable-header',
  //         renderCell:params=><Avatar src={`${imgurl}/avatar/${params.row.id}/${params.row.userAvatar}`} />,
  //         sortable: false,
  //         filterable: false,
  //         headerAlign: 'center',
  //         width: 64,
  //         editable: false,
  //       },
  //       {
  //       field: 'userName',
  //       headerName: 'UserName',
  //       // headerClassName: 'datatable-header',
  //         headerAlign: 'center',
  //       width: 150,
  //       editable: true,
  //       flex: 1,
  //     },
  //     {
  //       field: 'procCode',
  //       headerName: 'ProcCode',
  //       // headerClassName: 'datatable-header',
  //         headerAlign: 'center',
  //         type: 'singleSelect',
  //         valueOptions: procCode,
  //         valueGetter: ({ value, colDef }) => {
  //           const option = colDef.valueOptions.find(
  //             ({ value: optionValue }) => value === optionValue
  //           );
  //           return option.label;
  //         },
  //       width: 100,
  //       editable: true,
  //       flex: 1,
  //     },
  //     {
  //       field: 'userRole',
  //       headerName: 'Role',
  //       // headerClassName: 'datatable-header',
  //         headerAlign: 'center',
  //       // type: 'number',
  //       type: 'singleSelect',
  //         //type:'boolean',
  //         valueOptions: roleOptions,
  //         valueGetter: ({ value, colDef }) => {
  //           const option = colDef.valueOptions.find(
  //             ({ value: optionValue }) => value === optionValue
  //           );
  //           return option.label;
  //         },
  //       width: 150,
  //       editable: true,
  //       flex: 1,
  //     },
  //     {
  //         field: 'activeSts',
  //         headerName: 'Active',
  //         // headerClassName: 'datatable-header',
  //         headerAlign: 'center',
  //         // type: 'singleSelect',
  //         type:'boolean',
  //         // valueOptions:['male', 'female'],
  //         width: 40,
  //         editable: true,
  //         // cellClassName: params=> (params.value === 'male') ? 'super-app-positive' : 'super-app-negative',
  //     },

  //       // {
  //     //   field: 'fullName',
  //     //   headerName: 'Full name',
  //     //   description: 'This column has a value getter and is not sortable.',
  //     //   sortable: false,
  //     //   headerClassName: 'datatable-header',
  //     //     headerAlign: 'center',
  //     //   width: 160,
  //     //   valueGetter: (params) =>
  //     //     `${params.row.firstName || ''} ${params.row.lastName || ''}`,
  //     // },
  //     {
  //         field: 'udate',
  //         headerName: 'UpdateDate',
  //         // headerClassName: 'datatable-header',
  //         headerAlign: 'center',
  //         width: 180,
  //         // valueGetter: (params) => moment(params.row.cdate).format('YYYY-MM-DD HH:MM:SS'),
  //         renderCell: (params) => moment(params.row.cdate).format('YYYY-MM-DD HH:MM:SS'),
  //         editable: false,
  //         flex: 1,
  //     },
  //     {
  //         field: 'uuser',
  //         headerName: 'UpdateUser',
  //         // headerClassName: 'datatable-header',
  //         headerAlign: 'center',
  //         width: 100,
  //         editable: false,
  //         flex: 1,
  //     },
  //     {
  //         field: 'actions',
  //         headerName: 'Actions',
  //         type: 'actions',
  //         renderCell: params => <UsersActions {...{params, rowId, setRowId, webpath}} />,
  //         // headerClassName: 'datatable-header',
  //         headerAlign: 'center',
  //         width: 150,
  //         editable: false,
  //         // flex: 1,
  //     },
  // ],[rowId]);
    const fetchUsers = async () => {
      try {
        const result = await axios.get(`${apiurl}?mode=list`);
        
        // console.log(result);
        // console.log(result.data);
        // if(result.data.length>0) {
        if(result.data && result.data.message==="OK") {  
          // const data = await response.json();
          // console.log(result.data[0]);
          setData(result.data[0]);
          return result.data[0];
        }

      }
      catch(err) {
          console.log(err);
        }
      }

  useEffect(() => {
    if(user.user?.isAdmin < 1 ) {  // Role !== 'Admin'
      navigate("/")
    }}) 
    
  useEffect(() => {

        fetchUsers();
    
  },[])

  // useEffect(() => {
  //     setQuery(data)

  // },[data])


    // console.log(query)
  const _s = 120 
  const [screenH, setScreenH] = useState(window.innerHeight-_s)

  // useEffect(() => {
  //     if (values.searchTxt.length === 0 || values.searchTxt.length > 2)
  //         setQuery(values.searchTxt)

  //     // console.log("searchTxt Change")

  // },[values.searchTxt])

  useEffect(() => {

    window.addEventListener('resize', setScreenH(window.innerHeight-_s));

    return () => {
      window.removeEventListener('resize', setScreenH(window.innerHeight-_s));
    };

    
  }, [screenH]);
  
  // console.log(screenH)

  
  // !data? fetchUsers() : 
  // console.log(user);

  return (
    <>
    {user.user?.isAdmin==1 &&
    <Box className="flex flex-col w-svw sm:w-[calc(100vw-160px)] h-[calc(100vh-120px)]" > 
      <Header title="Users Manangement" 
              subtitle="Mananging the Users" />

        {/* <Box className='flex justify-center'>
        <Paper
            component="form"
            sx={{ m: '10px 4px', p: '2px', display: 'flex', width:'400px', justifyContent: 'center', alignItems: 'center', borderRadius: 2}}
        >
            
            <InputBase
                sx={{ ml: 1, flex: 1}}
                placeholder="Search data"
                inputProps={{ 'aria-label': 'search' }}
                value={searchTxt}
                onChange={(e) => setSearchTxt(e.target.value)}
            />
            <IconButton 
                type="button" 
                sx={{ p: '10px' }} 
                aria-label="search"
                color="info"
                onClick={handleSearch}
                onMouseDown={handleMouseDownSearchTxt}
            >
                <SearchIcon />
            </IconButton>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton 
                type="button" 
                color="error" 
                sx={{ p: '10px' }} 
                aria-label="clear search text"
                onClick={handleClickClearSearchTxt}
                onMouseDown={handleMouseDownSearchTxt}
            >
                <HighlightOffOutlinedIcon  />
            </IconButton>
        </Paper>
        </Box> */}
        {/* <Box >
            <Table data={data} />
        </Box> */}

      {/* <Notistack /> */}
        <Box 
            m="4px 0 0 0"
            height="76vh"

            // sx={{ 
            //     p: 0, height: `${screenH}px`,
            // }}
            // className="w-full "
            sx={{
            "& .MuiDataGrid-root": {
              border: "solid 1px #9e9e9e",
              backgroundColor: "#5176d9",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              color: '#112019',
              
            },
            "& .name-column--cell": {
              color: '#69f0ae',
              '&:hover': {
                backgroundColor: "#5176d9",
                // '@media (hover: none)': {
                //   backgroundColor: 'transparent',
                // },
              },
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: '#1d1d1d',
              borderBottom: "solid 2px #0c245c",
              color: "blue",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: '#0f3b5e',
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: '#0277bd',
              color:'#ffffff',
            },
            "& .MuiCheckbox-root": {
              color: `'#69f0ae' !important`,
            },
            // "& .MuiSvgIcon-root": {
            //     fill: "#9e9a9a",
            // },
            "& .MuiInputBase-input.MuiInput-input": {
                color: "#9e9a9a",
            },
            "& .MuiTablePagination-root": {
                color: "#9e9a9a",
            }
          }}
        >
        <Link to="/users/addnew" 
          className="inline-block ml-2 p-1 px-1 text-green-400 bg-slate-500 rounded hover:bg-teal-500"
        >
          Add User.
        </Link>
        {data && 
            <DataTable 
              title="Users Manangement" 
              subtitle="Managing the Users"
              column={columns} 
              data={data} 
              pageSize={50} 
              fieldrowID="id"
              {...{rowId, setRowId}} 
              link="/user/addnew"
            />
          }
        </Box>
    </Box>
    }
    </>
  )
}

export default UsersList